export default { //存放变量的容器
  // 公共接口地址
  baseURL: 'https://xitong.beijingwanyu.com/index/',
  // baseURL: 'https://www.beijingwanyu.com/index/',


  // 上传图片地址
  imageUrl: 'https://xitong.beijingwanyu.com/index/config/uploadimage',
  // imageUrl: 'https://www.beijingwanyu.com/index/config/uploadimage',

  // 图片拼接地址
  imgUrl: 'https://xitong.beijingwanyu.com',
  // imgUrl: 'https://www.beijingwanyu.com',

  fileUrl: 'https://xitong.beijingwanyu.com/index/config/uploadfile',
  // fileUrl: 'https://www.beijingwanyu.com/index/config/uploadfile',

}